export default __webpack_public_path__ + "static/media/testimonial_img.9a297930.PNG";